import { IThunderboltEntry } from '@wix/editor-elements-types';

const entry: IThunderboltEntry = {
  loadComponent: hostAPI => {
    hostAPI.registerComponent('SignatureInput', () => {
      return Promise.all([
        import(
          './viewer/SignatureInput' /* webpackChunkName: "SignatureInput" */
        ),
        import(
          './viewer/SignatureInput.controller' /* webpackChunkName: "SignatureInput" */
        ),
      ]).then(([componentModule, controllerModule]) => {
        return {
          component: componentModule.default,
          controller: controllerModule.default,
        };
      });
    });
  },
};

export default entry;
